export default class RestError {
	constructor(code, message) {
		this.status_code = code;
		this.message = message;
	}
}
